import { atom, useAtom, useAtomValue } from "jotai";

import { type Option } from "#/types/options";

export const optionAtom = atom<Option>();

export const bestPricesAtom = atom((get) => {
  const option = get(optionAtom);
  if (!option) return { bestBid: NaN, bestAsk: NaN };

  const bestBid =
    option.bids && option.bids.length > 0
      ? Math.max(...option.bids.map((bid) => bid.price))
      : NaN;

  const bestAsk =
    option.asks && option.asks.length > 0
      ? Math.min(...option.asks.map((ask) => ask.price))
      : NaN;

  return { bestBid, bestAsk };
});

export const useOption = () => {
  const [option, setOption] = useAtom(optionAtom);
  const bestPrices = useAtomValue(bestPricesAtom);

  return {
    option,
    setOption,
    ...bestPrices,
  };
};
